import { Button } from "@/components/ui/button";
import { MapPin, Plane, Building, Navigation, Globe } from "lucide-react";
import StandardSection from "./ui/StandardSection";
import { assetUrl } from "@/utils/assetUrl";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/utils/authContext";

const coverageFeatures = [
  {
    icon: MapPin,
    label: "50+ Cities",
    color: "text-primary-600",
  },
  {
    icon: Plane,
    label: "Major Airports",
    color: "text-forest-custom",
  },
  {
    icon: Building,
    label: "CBD Areas",
    color: "text-primary-600",
  },
  {
    icon: Navigation,
    label: "Highway Spots",
    color: "text-forest-custom",
  },
];

interface CoverageUSPProps {
  isLoginEnabled: boolean;
  isExploreEnabled: boolean;
  base_path: string;
}

export default function CoverageUSP({
  isLoginEnabled,
  isExploreEnabled,
  base_path
}: CoverageUSPProps) {
  const navigate = useNavigate();

  const { isLoggedIn } = useAuth();

  const handleFindBillboard = () => {
    localStorage.setItem('clearStartCampaignFilters', 'true');
    if (!isLoggedIn) {
      navigate(`${base_path}/explore`);
    } else {
      navigate(`${base_path}/propertylist`);
    }

  };

  return (
    <>
      <StandardSection id="coverage" background="light">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-primary-100 to-forest-100 border border-primary-200 text-primary-700 px-6 py-3 rounded-full text-sm mb-8 shadow-sm">
              <Globe className="h-4 w-4 text-primary-600" />
              <span className="text-lg sm:text-xl">
              Global Coverage
            </span>
              <MapPin className="h-4 w-4 text-forest-custom" />
            </div>

            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight FontStyles mb-3 sm:mb-4">
              <span className="text-gray-900 block">
                From Main Street to the World—OOH Made Easy
              </span>
            </h2>

            <p className="text-xl text-gray-700 leading-relaxed mb-8">
              Get your brand in front of the right audience—whether you're a
              local business expanding abroad or a startup testing new markets.
              Our platform gives you affordable access to premium billboards in
              top cities, airports, and travel hubs worldwide.
            </p>
            <div className="grid grid-cols-2 gap-6 mb-8">
              {coverageFeatures.map((feature, index) => {
                const IconComponent = feature.icon;
                return (
                  <div key={index} className="flex items-center">
                    <IconComponent
                      className={`h-6 w-6 ${feature.color} mr-3`}
                    />
                    <span className="font-semibold text-gray-900">
                      {feature.label}
                    </span>
                  </div>
                );
              })}
            </div>
            {isLoginEnabled && isExploreEnabled && (
              <Button
                onClick={handleFindBillboard}
                size="lg"
                className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-4 text-lg font-semibold"
                data-testid="button-find-perfect-billboard"
              >
                Explore Now
              </Button>
            )}
          </div>
          <div className="relative">
            <img
              src={`${assetUrl("times-square-5913240_1755604729399.jpg")}`}
              alt="Times Square Billboard Advertising"
              className="w-full rounded-3xl shadow-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-amber-500/20 to-green-500/20 rounded-3xl"></div>
          </div>
        </div>
      </StandardSection>

    </>
  );
}
